<template>
  <div style="margin-top:20px;">
    <h3 class="mx-auto" style="margin-top:10px;">
      <span>申請者情報入力</span>
    </h3>
    <div class="left" style="margin-top:20px;">
      <div>
        <span style="font-size:130%;">{{inputFieldExplanation }}</span>
      </div>
    </div>
    <ValidationObserver ref="obs" v-slot="{ invalid }">
      <div style="margin-top:10px;">
        <!-- 氏名 -->
        <div class="form-row mb-1">
          <div class="col-md-4 mb-3">
            <label for="lastName">
              姓
              <span class="badge badge-pill badge badge-light" style="color:#ff0000;">必須</span>
            </label>
            <ValidationProvider
              rules="required|max: 50"
              vid="lastName"
              name="姓"
              v-slot="{ errors }"
            >
              <input
                class="form-control"
                id="lastName"
                type="text"
                placeholder="例）鈴木"
                v-model="lastName"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="col-md-4 mb-3">
            <label for="firstName">
              名
              <span class="badge badge-pill badge badge-light" style="color:#ff0000;">必須</span>
            </label>
            <ValidationProvider
              rules="required|max: 50"
              vid="firstName"
              name="名"
              v-slot="{ errors }"
            >
              <input
                class="form-control"
                id="firstName"
                type="text"
                placeholder="例）一郎"
                v-model="firstName"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-md-4 mb-3">
            <label for="maidenName">旧姓</label>
            <ValidationProvider rules="max: 50" vid="maidenName" name="旧姓" v-slot="{ errors }">
              <input
                class="form-control"
                id="maidenName"
                type="text"
                placeholder="例）佐藤"
                v-model="maidenName"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <!-- 氏名カナ -->
        <div class="form-row mb-1">
          <div class="col-md-4 mb-3">
            <label for="lastNameKanaStr">
              姓（カナ）
              <span class="badge badge-pill badge badge-light" style="color:#ff0000;">必須</span>
            </label>
            <!-- eslint-disable-next-line no-irregular-whitespace -->
            <ValidationProvider rules="required|max: 50|regex:^([ァ-ヴ][ァ-ヴー・　]*)$"
              vid="lastNameKanaStr"
              name="姓（カナ）"
              v-slot="{ errors }"
            >
              <input
                class="form-control"
                id="lastNameKanaStr"
                type="text"
                placeholder="例）スズキ"
                v-model="lastNameKanaStr"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-md-4 mb-3">
            <label for="firstNameKanaStr">
              名（カナ）
              <span class="badge badge-pill badge badge-light" style="color:#ff0000;">必須</span>
            </label>
            <!-- eslint-disable-next-line no-irregular-whitespace -->
            <ValidationProvider rules="required|max: 50|regex:^([ァ-ヴ][ァ-ヴー・　]*)$"
              vid="firstNameKanaStr"
              name="名（カナ）"
              v-slot="{ errors }"
            >
              <input
                class="form-control"
                id="firstNameKanaStr"
                type="text"
                placeholder="例）イチロウ"
                v-model="firstNameKanaStr"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-md-4 mb-2">
            <label for="maidenNameKanaStr">旧姓（カナ）</label>
            <!-- eslint-disable-next-line no-irregular-whitespace -->
            <ValidationProvider rules="max: 50|regex:^([ァ-ヴ][ァ-ヴー・　]*)$"
              vid="maidenNameKanaStr"
              name="旧姓（カナ）"
              v-slot="{ errors }"
            >
              <input
                class="form-control"
                id="maidenNameKanaStr"
                type="text"
                placeholder="例）サトウ"
                v-model="maidenNameKanaStr"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <!-- 生年月日・性別 -->
        <div class="form-row mb-1">
          <div class="col-md-3 mb-3">
            <label class="col-form-label col-md-*" for="birthDateStr">
              生年月日（８桁）
              <span class="badge badge-pill badge badge-light" style="color:#ff0000;">必須</span>
            </label>
            <ValidationProvider
              rules="required|length:8|date_format"
              vid="birthDateStr"
              name="生年月日"
              v-slot="{ errors }"
            >
              <input
                class="form-control"
                id="birthDateStr"
                type="number" pattern="\d*"
                placeholder="例）20100101"
                v-model="birthDateStr"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form-group col-md-9">
            <fieldset>
              <legend class="col-form-label ol-md-*">
                性別
                <span class="badge badge-pill badge badge-light" style="color:#ff0000;">必須</span>
              </legend>
              <div class="col-sm-6">
                <ValidationProvider rules="required" vid="gender" v-slot="{ errors }">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      id="wooman"
                      name="性別"
                      class="custom-control-input"
                      value="2"
                      v-model="gender"
                    />
                    <label class="custom-control-label" for="wooman">女性</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      id="man"
                      name="性別"
                      value="1"
                      class="custom-control-input"
                      v-model="gender"
                    />
                    <label class="custom-control-label" for="man">男性</label>
                  </div>
                  <span style="color:#ff0000;">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </fieldset>
          </div>
        </div>

        <!--住所-->
        <div class="form-row">
          <div class="col-md-3 mb-3">
            <label for="postcodeNumStr">
              郵便番号（ハイフンなし）
              <span class="badge badge-pill badge badge-light" style="color:#ff0000;">必須</span>
            </label>
            <ValidationProvider
              rules="required|length:7"
              vid="postcodeNumStr"
              name="郵便番号"
              v-slot="{ errors }"
            >
              <input
                type="number" pattern="\d*"
                id="postcodeNumStr"
                name="郵便番号"
                class="form-control"
                placeholder="例）1010054"
                v-model="postcodeNumStr"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-md-3 mb-3">
            <label for="prefectureStr">
              住所（都道府県）
              <span class="badge badge-pill badge badge-light" style="color:#ff0000;">必須</span>
            </label>
            <ValidationProvider
              rules="required"
              vid="prefectureStr"
              name="都道府県"
              v-slot="{ errors }"
            >
              <select
                id="prefectureStr"
                name="都道府県"
                class="form-control input-lg"
                placeholder="例）東京都"
                v-model="prefectureStr"
                v-bind:class="{ entered: isEntered }"
              >
                <option value disabled selected style="display:none;">例）東京都</option>
                <option value="北海道">北海道</option>
                <option value="青森県">青森県</option>
                <option value="岩手県">岩手県</option>
                <option value="宮城県">宮城県</option>
                <option value="秋田県">秋田県</option>
                <option value="山形県">山形県</option>
                <option value="福島県">福島県</option>
                <option value="茨城県">茨城県</option>
                <option value="栃木県">栃木県</option>
                <option value="群馬県">群馬県</option>
                <option value="埼玉県">埼玉県</option>
                <option value="千葉県">千葉県</option>
                <option value="東京都">東京都</option>
                <option value="神奈川県">神奈川県</option>
                <option value="新潟県">新潟県</option>
                <option value="富山県">富山県</option>
                <option value="石川県">石川県</option>
                <option value="福井県">福井県</option>
                <option value="山梨県">山梨県</option>
                <option value="長野県">長野県</option>
                <option value="岐阜県">岐阜県</option>
                <option value="静岡県">静岡県</option>
                <option value="愛知県">愛知県</option>
                <option value="三重県">三重県</option>
                <option value="滋賀県">滋賀県</option>
                <option value="京都府">京都府</option>
                <option value="大阪府">大阪府</option>
                <option value="兵庫県">兵庫県</option>
                <option value="奈良県">奈良県</option>
                <option value="和歌山県">和歌山県</option>
                <option value="鳥取県">鳥取県</option>
                <option value="島根県">島根県</option>
                <option value="岡山県">岡山県</option>
                <option value="広島県">広島県</option>
                <option value="山口県">山口県</option>
                <option value="徳島県">徳島県</option>
                <option value="香川県">香川県</option>
                <option value="愛媛県">愛媛県</option>
                <option value="高知県">高知県</option>
                <option value="福岡県">福岡県</option>
                <option value="佐賀県">佐賀県</option>
                <option value="長崎県">長崎県</option>
                <option value="熊本県">熊本県</option>
                <option value="大分県">大分県</option>
                <option value="宮崎県">宮崎県</option>
                <option value="鹿児島県">鹿児島県</option>
                <option value="沖縄県">沖縄県</option>
              </select>

              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-md-6 mb-3">
            <label for="city">
              住所（市区町村）
              <span class="badge badge-pill badge badge-light" style="color:#ff0000;">必須</span>
            </label>
            <ValidationProvider rules="required|max: 24" vid="city" name="市区町村" v-slot="{ errors }">
              <input
                type="text"
                id="city"
                name="市区町村"
                class="form-control"
                placeholder="例）千代田区"
                v-model="city"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-3 mb-3">
            <label for="town">
              住所（丁目）
              <span class="badge badge-pill badge badge-light" style="color:#ff0000;">必須</span>
            </label>
            <ValidationProvider rules="required|max: 24" vid="town" name="丁目" v-slot="{ errors }">
              <input
                type="text"
                id="town"
                name="丁目"
                class="form-control"
                placeholder="例）神田錦町１丁目"
                v-model="town"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-md-3 mb-3">
            <label for="lotNumber">
              住所（番地）
              <span class="badge badge-pill badge badge-light" style="color:#ff0000;">必須</span>
            </label>
            <ValidationProvider
              rules="required|max: 24"
              vid="lotNumber"
              name="番地"
              v-slot="{ errors }"
            >
              <input
                type="text"
                id="lotNumber"
                name="番地"
                class="form-control"
                placeholder="例）１番地"
                v-model="lotNumber"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-md-6 mb-3">
            <label for="detailAddress">住所（建物名）</label>
            <ValidationProvider rules="max: 72" vid="detailAddress" name="建物名" v-slot="{ errors }">
              <input
                type="text"
                id="detailAddress"
                name="detailAddress"
                class="form-control"
                placeholder="例）XXビル１階"
                v-model="detailAddress"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="form-row">
          <div class="col-md-3 mb-3">
            <label for="telNumber">
              電話番号１
              <span class="badge badge-pill badge badge-light" style="color:#ff0000;">必須</span>
            </label>
            <ValidationProvider
              rules="required|max:15|regex:^[0-9\-]+$"
              vid="telNumber"
              v-slot="{ errors }"
            >
              <input
                type="tel"
                id="telNumber"
                name="電話番号１"
                class="form-control"
                placeholder="例）05011110000"
                v-model="telNumber"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-md-3 mb-3">
            <ValidationProvider
              rules="max:15|regex:^[0-9\-]+$"
              vid="mobileNumber"
              v-slot="{ errors }"
            >
              <label for="mobileNumber">電話番号２</label>
              <input
                type="tel" 
                id="mobileNumber"
                name="電話番号２"
                class="form-control"
                placeholder="例）08011110000"
                v-model="mobileNumber"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-md-6">
            <label for="emailAddress">E-mail</label>
            <ValidationProvider rules="email|max: 256" vid="emailAddress" v-slot="{ errors }">
              <input
                type="email"
                id="emailAddress"
                name="E-mail"
                class="form-control"
                placeholder="例）xxxxx@gmail.com"
                v-model="emailAddress"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <!-- 健康保険証 -->
        <hr />
        <div class="form-group pb-3">
          <ValidationProvider
            rules="requird_insured:@careInsuredCheck"
            vid="insuredCheck"
            v-slot="{ errors }"
          >
            <div class="custom-control custom-checkbox">
              <input
                id="insuredCheck"
                class="custom-control-input"
                type="checkbox"
                v-model="insuredCheck"
              />
              <label class="custom-control-label" for="insuredCheck">健康保険証を添付する</label>
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
        </div>
        <div class="form-row" v-show="insuredCheck">
          <div class="col-md-3 mb-2">
            <label for="insuredPersonSymbolStr">
              <span>被保険者記号</span>
              <span class="badge badge-secondary">※漢字やひらがな等の場合ONにしてください</span>
              <span class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="symbolToggle" v-model="symbolToggle">
                <label class="custom-control-label" for="symbolToggle">全角入力</label>
              </span>
            </label>
            <ValidationProvider
              rules="max:19"
              vid="insuredPersonSymbolStr"
              v-slot="{ errors }"
            >
              <input v-if="!symbolToggle" 
              type="number" pattern="\d*"
              id="insuredPersonSymbolStr" 
              name="被保険者記号" 
              class="form-control" 
              placeholder="例）1234"
              v-model="insuredPersonSymbolStr" />
              <input v-if="symbolToggle" 
                type="text" 
                id="insuredPersonSymbolStr" 
                name="被保険者記号" 
                class="form-control" 
                placeholder="例）１２３４"
                v-model="insuredPersonSymbolStr" />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>

          </div>  
          <div class="col-md-3 mb-2">
            <label for="insuredPersonNumberStr">
              被保険者番号
              <span class="badge badge-pill badge badge-light" style="color:#ff0000;">必須</span>
              <span class="badge badge-secondary">※漢字やひらがな等の場合ONにしてください</span>
              <span class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="numberToggle" v-model="numberToggle">
                <label class="custom-control-label" for="numberToggle">全角入力</label>
              </span>                
            </label>
            <ValidationProvider
              rules="max:19"
              vid="insuredPersonNumberStr"
              v-slot="{ errors }"
              ref="insuredPersonNumberStrProvider"
            >
              <input v-if="!numberToggle"
                type="number" pattern="\d*"
                id="insuredPersonNumberStr" 
                name="被保険者番号" 
                class="form-control" 
                placeholder="例）1234567"
                v-model="insuredPersonNumberStr" />
              <input v-if="numberToggle" 
                type="text" 
                id="insuredPersonNumberStr" 
                name="被保険者番号" 
                class="form-control" 
                placeholder="例）１２３４５６７"
                v-model="insuredPersonNumberStr" />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          
          </div>

          <div class="col-md-2">
            <label for="insuredPersonBranchNumber">枝番</label>
            <ValidationProvider
              rules="numeric|length:2"
              vid="insuredPersonBranchNumber"
              v-slot="{ errors }"
            >
              <input
                type="number" pattern="\d*"
                id="insuredPersonBranchNumber"
                name="枝番"
                class="form-control"
                placeholder="例）01"
                v-model="insuredPersonBranchNumber"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-md-4">
            <label for="insurerNumber">
              保険者番号
              <span class="badge badge-pill badge badge-light" style="color:#ff0000;">必須</span>
            </label>
            <ValidationProvider rules="numeric|max:16" vid="insurerNumber" v-slot="{ errors }" ref="insurerNumberProvider">
              <input
                type="number" pattern="\d*"
                id="insurerNumber"
                name="保険者番号"
                class="form-control"
                placeholder="例）88888888"
                v-model="insurerNumber"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <!-- 健康保険証画像 -->
        <div class="form-row mb-1" v-show="insuredCheck">
          <div class="col-md-6">
            <!-- （縦54ミリ、横86ミリ） -->
            <div
              class="card d-flex align-items-center justify-content-center"
              style="margin-top:20px; "
            >
              <div class="card" style="margin-top:20px; ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="244"
                  min-height="153"
                  focusable="false"
                  aria-label="Placeholder: Image cap"
                  preserveAspectRatio="xMidYMid slice"
                  v-show="data.insuranceCardImageFrontOnChanged === false"
                >
                  <title>Placeholder</title>
                  <rect fill="#868e96" width="100%" height="100%" />
                  <text fill="#dee2e6" dy=".3em" x="40%" y="50%">No Image</text>
                </svg>
                <img
                  :src="data.insuranceCardImageFrontImage"
                  width="244"
                  min-height="153"
                  alt="健康保険証の画像（表）"
                  v-show="data.insuranceCardImageFrontOnChanged === true"
                />
              </div>
              <p>
                健康保険証の画像（表）
                <span
                  class="badge badge-pill badge badge-light"
                  style="color:#ff0000;"
                >必須</span>
              </p>
            </div>

            <!-- Click Action -->
            <div style="margin-top:20px;">
              <ValidationProvider
                rules="image|size:10000"
                ref="insuranceCardImageFrontProvider"
                name="健康保険証の画像（表）"
                vid="insuranceCardImageFront"
                v-slot="{validate, errors }"
              >
                <div class="custom-file">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="insuranceCardImageFront"
                    ref="insuranceCardImageFront"
                    @input="validate"
                    @change="setInsuranceCardImageFront"
                  />
                  <label
                    class="custom-file-label"
                    for="insuranceCardImageFront"
                    data-browse="画像を取得"
                    required
                  >カメラ撮影Orファイル添付</label>
                </div>
                <p>
                  <span style="color:#ff0000;">{{ errors[0] }}</span>
                </p>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6">
            <!-- （縦54ミリ、横86ミリ） -->
            <div
              class="card d-flex align-items-center justify-content-center"
              style="margin-top:20px; "
            >
              <div class="card" style="margin-top:20px; ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="244"
                  min-height="153"
                  focusable="false"
                  aria-label="Placeholder: Image cap"
                  preserveAspectRatio="xMidYMid slice"
                  v-show="data.insuranceCardImageBackOnChanged === false"
                >
                  <title>Placeholder</title>
                  <rect fill="#868e96" width="100%" height="100%" />
                  <text fill="#dee2e6" dy=".3em" x="40%" y="50%">No Image</text>
                </svg>
                <img
                  :src="data.insuranceCardImageBackImage"
                  width="244"
                  min-height="153"
                  alt="健康保険証の画像（裏）"
                  v-show="data.insuranceCardImageBackOnChanged === true"
                />
              </div>
              <p>健康保険証の画像（裏）</p>
            </div>

            <!-- Click Action -->
            <div style="margin-top:20px;">
              <ValidationProvider
                rules="image|size:10000"
                ref="insuranceCardImageBackProvider"
                name="健康保険証の画像（裏）"
                vid="insuranceCardImageBack"
                v-slot="{validate, errors }"
              >
                <div class="custom-file">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="insuranceCardImageBack"
                    ref="insuranceCardImageBack"
                    @input="validate"
                    @change="setInsuranceCardImageBack"
                  />
                  <label
                    class="custom-file-label"
                    for="insuranceCardImageBack"
                    data-browse="画像を取得"
                  >カメラ撮影Orファイル添付</label>
                </div>
                <p>
                  <span style="color:#ff0000;">{{ errors[0] }}</span>
                </p>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <!-- 介護保険証 -->
        <hr />
        <div class="form-group pb-3">
          <ValidationProvider
            rules="requird_careInsured:@insuredCheck"
            vid="careInsuredCheck"
            v-slot="{ errors }"
          >
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                id="careInsuredCheck"
                class="custom-control-input"
                v-model="careInsuredCheck"
              />
              <label class="custom-control-label" for="careInsuredCheck">介護保険証を添付する</label>
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
        </div>
        <div class="form-row" v-show="careInsuredCheck">
          <div class="col-md-4 mb-3">
            <label for="careInsuredPersonNumber">
              被保険者番号
              <span class="badge badge-pill badge badge-light" style="color:#ff0000;">必須</span>
            </label>
            <ValidationProvider
              rules="numeric|max: 10"
              ref="careInsuredPersonNumberProvider"
              vid="careInsuredPersonNumber"
              v-slot="{ errors }"
            >
              <input
                type="number" pattern="\d*"
                id="careInsuredPersonNumber"
                name="被保険者番号"
                class="form-control"
                placeholder="例）88888888"
                v-model="careInsuredPersonNumber"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="col-md-4 mb-3">
            <label for="careDescribedInsurerNumber">
              保険者番号
              <span class="badge badge-pill badge badge-light" style="color:#ff0000;">必須</span>
            </label>
            <ValidationProvider
              rules="numeric|max: 8"
              ref="careDescribedInsurerNumberProvider"
              vid="careDescribedInsurerNumber"
              v-slot="{ errors }"
            >
              <input
                type="number" pattern="\d*"
                id="careDescribedInsurerNumber"
                name="保険者番号"
                class="form-control"
                placeholder="例）1234567"
                v-model="careDescribedInsurerNumber"
              />
              <span style="color:#ff0000;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <!-- 介護保険証画像 -->
        <div class="form-row mb-1" v-show="careInsuredCheck">
          <div class="col-md-6">
            <!-- （縦54ミリ、横86ミリ） -->
            <div
              class="card d-flex align-items-center justify-content-center"
              style="margin-top:20px; "
            >
              <div class="card" style="margin-top:20px; ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="244"
                  min-height="153"
                  focusable="false"
                  aria-label="Placeholder: Image cap"
                  preserveAspectRatio="xMidYMid slice"
                  v-show="data.careInsuranceCardImageFrontOnChanged === false"
                >
                  <title>Placeholder</title>
                  <rect fill="#868e96" width="100%" height="100%" />
                  <text fill="#dee2e6" dy=".3em" x="40%" y="50%">No Image</text>
                </svg>
                <img
                  :src="data.careInsuranceCardImageFrontImage"
                  width="244"
                  min-height="153"
                  alt="保険証の画像（表）"
                  v-show="data.careInsuranceCardImageFrontOnChanged === true"
                />
              </div>
              <p>
                介護保険証の画像（表）
                <span
                  class="badge badge-pill badge badge-light"
                  style="color:#ff0000;"
                >必須</span>
              </p>
            </div>

            <!-- Click Action -->
            <div style="margin-top:20px;">
              <ValidationProvider
                rules="image|size:10000"
                ref="careInsuCardImageFrontProvider"
                name="介護保険証の画像（表）"
                vid="careInsuCardImageFront"
                v-slot="{validate, errors }"
              >
                <div class="custom-file">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="careInsuCardImageFront"
                    ref="careInsuCardImageFront"
                    @input="validate"
                    @change="setCareInsuCardImageFront"
                  />
                  <label
                    class="custom-file-label"
                    for="careInsuCardImageFront"
                    data-browse="画像を取得"
                  >カメラ撮影Orファイル添付</label>
                </div>
                <p>
                  <span style="color:#ff0000;">{{ errors[0] }}</span>
                </p>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6">
            <!-- （縦54ミリ、横86ミリ） -->
            <div
              class="card d-flex align-items-center justify-content-center"
              style="margin-top:20px; "
            >
              <div class="card" style="margin-top:20px; ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="244"
                  min-height="153"
                  focusable="false"
                  aria-label="Placeholder: Image cap"
                  preserveAspectRatio="xMidYMid slice"
                  v-show="data.careInsuranceCardImageBackOnChanged === false"
                >
                  <title>Placeholder</title>
                  <rect fill="#868e96" width="100%" height="100%" />
                  <text fill="#dee2e6" dy=".3em" x="40%" y="50%">No Image</text>
                </svg>
                <img
                  :src="data.careInsuranceCardImageBackImage"
                  width="244"
                  min-height="153"
                  alt="介護保険証の画像（裏）"
                  v-show="data.careInsuranceCardImageBackOnChanged === true"
                />
              </div>
              <p>介護保険証の画像（裏）</p>
            </div>

            <!-- Click Action -->
            <div style="margin-top:20px;">
              <ValidationProvider
                rules="image|size:10000"
                ref="careInsuCardImageBackProvider"
                name="介護保険証の画像（裏）"
                vid="careInsuCardImageBack"
                v-slot="{validate, errors }"
              >
                <div class="custom-file">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="careInsuCardImageBack"
                    ref="careInsuCardImageBack"
                    @input="validate"
                    @change="setCareInsuCardImageBack"
                  />
                  <label
                    class="custom-file-label"
                    for="careInsuCardImageBack"
                    data-browse="画像を取得"
                  >カメラ撮影Orファイル添付</label>
                </div>
                <p>
                  <span style="color:#ff0000;">{{ errors[0] }}</span>
                </p>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <!-- 付帯情報 -->
        <!-- Consent modal -->
        <ValidationProvider vid="invalidCheck" name="利用規約" :rules="{ required: { allowFalse: false } }" v-slot="{ errors }">
          <consent id="invalidCheck" 
          v-model="invalidCheck" 
          @toggleConsentCheck="toggleConsentCheck" 
          show-checkbox="true"
          :rule-explanation="ruleExplanation"
          :path="consentPath"/>
          <p>
            <span style="color:#ff0000;">{{ errors[0] }}</span>
          </p>
        </ValidationProvider>
        <!--広域連携フラグ-->
        <div class="form-group pb-3">
          <ValidationProvider vid="wdAraLnkConsentFlagBool" name="広域連携" v-slot="{ errors }">
            <div class="custom-control custom-checkbox">
              <input
                class="custom-control-input"
                type="checkbox"
                id="wdAraLnkConsentFlagBool"
                v-model="wdAraLnkConsentFlagBool"
              />
              <label class="custom-control-label" for="wdAraLnkConsentFlagBool">
                {{wdAraLnkDisplayName}}
                <span
                  class="badge badge-pill badge badge-light"
                  style="color:#ff0000;"
                  v-if="wdAraLnkRequiredFlag"
                >必須</span>
              </label>
              <div class="mb-3">{{wdAraLnkExplanation}}</div>
            </div>
            <span style="color:#ff0000;">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <!--匿名２次利用フラグ-->
        <div class="form-group pb-3">
          <ValidationProvider vid="anonymizeFlagBool" name="匿名２次利用" v-slot="{ errors }">
            <div class="custom-control custom-checkbox">
              <input
                class="custom-control-input"
                type="checkbox"
                id="anonymizeFlagBool"
                v-model="anonymizeFlagBool"
              />
              <label class="custom-control-label" for="anonymizeFlagBool">
                {{anonymizeDisplayName}}
                <span
                  class="badge badge-pill badge badge-light"
                  style="color:#ff0000;"
                  v-if="anonymizeRequiredFlag"
                >必須</span>
              </label>
              <div class="mb-3">{{anonymizeExplanation}}</div>
            </div>
            <span style="color:#ff0000;">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <!--包括同意フラグ-->
        <div class="form-group pb-3">
          <ValidationProvider vid="inclusiveConsFlagBool" name="包括同意" v-slot="{ errors }">
            <div class="custom-control custom-checkbox">
              <input
                class="custom-control-input"
                type="checkbox"
                id="inclusiveConsFlagBool"
                v-model="inclusiveConsFlagBool"
              />
              <label class="custom-control-label" for="inclusiveConsFlagBool">
                {{inclusiveConsDisplayName}}
                <span
                  class="badge badge-pill badge badge-light"
                  style="color:#ff0000;"
                  v-if="inclusiveConsRequiredFlag"
                >必須</span>
              </label>

              <div class="mb-3">{{inclusiveConsExplanation}}</div>
            </div>
            <span style="color:#ff0000;">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <!-- Textarea -->
        <div class="form-group">
          <label for="applicantNotices">特記事項</label>
          <ValidationProvider
            rules="max: 200"
            vid="applicantNotices"
            name="特記事項"
            v-slot="{ errors }"
          >
            <textarea
              class="form-control"
              id="applicantNotices"
              placeholder="特記事項を記載ください。"
              rows="3"
              v-model="applicantNotices"
            ></textarea>
            <span style="color:#ff0000;">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
      </div>
      <!-- End Resident Data -->
      <!-- Click Action -->
      <div class="form-group row" style="margin-top:50px;">
        <div class="col-sm-12">
          <button class="btn btn-primary btn-block" :disabled="invalid" v-on:click="onnext">参加申請する</button>
          <button class="btn btn-primary btn-block" v-on:click="onback">戻る</button>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import axiosJsonpAdapter from "axios-jsonp";
import "es6-promise/auto";
import "fetch-polyfill";

Vue.use(VueAxios, axios);
import { mapMutations } from "vuex";

import Consent from './Consent.vue'

export default {
  name: "InputInfomation",
  components: {
    Consent
  },  
  data() {
    return {
      invalidCheck: false,
      isEntered: false,
      fileType: "",
      data: {
        insuranceCardImageFrontOnChanged:
          this.$store.state.images.insuranceCardImageFrontOnChanged || false,
        insuranceCardImageFrontImage:
          this.$store.state.images.insuranceCardImageFrontImage || "",

        insuranceCardImageBackOnChanged:
          this.$store.state.images.insuranceCardImageBackOnChanged || false,
        insuranceCardImageBackImage:
          this.$store.state.images.insuranceCardImageBackImage || "",

        careInsuranceCardImageFrontOnChanged:
          this.$store.state.images.careInsuranceCardImageFrontOnChanged ||
          false,
        careInsuranceCardImageFrontImage:
          this.$store.state.images.careInsuranceCardImageFrontImage || "",

        careInsuranceCardImageBackOnChanged:
          this.$store.state.images.careInsuranceCardImageBackOnChanged || false,

        careInsuranceCardImageBackImage:
          this.$store.state.images.careInsuranceCardImageBackImage || ""
      }
    };
  },
  watch: {
    // 都道府県選択済み判定
    async prefectureStr(val) {
      this.onentered(val);
    },
    // 郵便番号検索処理
    async postcodeNumStr(val) {
      if (7 > val.length) {
        return;
      }
      this.address1 = this.prefectureStr;
      this.address2 = this.city;
      this.address3 = this.town;
      var data = {
        results: [
          {
            address1: this.prefectureStr,
            address2: this.city,
            address3: this.town
          }
        ]
      };
      // https://zipcloud.ibsnet.co.jp/
      await axios
        .get("https://zipcloud.ibsnet.co.jp/api/search", {
          adapter: axiosJsonpAdapter,
          params: {
            zipcode: val
          }
        })
        .then(function(r) {
          if (200 === r.status) {
            data = r.data;
          }
        });

      this.$store.commit("setPrefectureStr", data.results[0].address1);
      this.$store.commit("setCity", data.results[0].address2);
      this.$store.commit("setTown", data.results[0].address3);
    },
    symbolToggle: function () {
      //全角入力切替で、値をクリアする
      this.$store.commit("setInsuredPersonSymbolStr", "");
    },
    numberToggle: function () {
      //全角入力切替で、値をクリアする
      this.$store.commit("setInsuredPersonNumberStr", "");
    },
    insuredCheck: function () {
      //切り替え時エラーを解除
      this.$refs.insuredPersonNumberStrProvider.reset();
      this.$refs.insurerNumberProvider.reset();
      this.$refs.insuranceCardImageFrontProvider.reset();
    },
    careInsuredCheck: function () {
      //切り替え時エラーを解除
      this.$refs.careDescribedInsurerNumberProvider.reset();
      this.$refs.careInsuredPersonNumberProvider.reset();
      this.$refs.careInsuCardImageFrontProvider.reset();
    },     
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    // 都道府県の選択済み判定
    this.onentered(this.prefectureStr);
    //IE11対応
    this.$refs.obs.reset();
    this.$refs.obs.setErrors({});

  },
  methods: {
    ...mapMutations(["ehrSystem", "consentApplicant"]),
    isEmpty(obj) {
      return !Object.keys(obj).length;
    },
    //都道府県選択済み
    onentered(val) {
      if ("" === val) {
        this.isEntered = false;
        return;
      }
      this.isEntered = true;
    },
    //同意チェック
    toggleConsentCheck(value) {
        this.invalidCheck = value;
    },
    onnext: function() {
      
      // 同意申請登録
      let phrSystemLink = {};
      phrSystemLink.consentApplicant = {};
      phrSystemLink.consentApplicant = this.$store.state.consentApplicant;

      //PHRからの遷移の時だけ設定する
      if(this.$store.state.phrSystem.phrAlias){
        phrSystemLink.phrSystem = {};
        phrSystemLink.phrSystem.phrAlias = this.$store.state.phrSystem.phrAlias;
        phrSystemLink.phrUserId = this.$store.state.phrSystemLink.phrUserId;
      }

      // 開始
      var isInitialized = false;
      this.$store.commit("setIsInitialized", isInitialized);

      //入力バリデーション及び、申請者情報登録を実行（サーバーサードで保険証の入力チェック）
      axios
        .post(
          this.$store.state.defaultParams.requestDomain +
            "/rest/anonymous/consentapplicant/create",
          phrSystemLink
        )
        .then(response => {
          if (!this.isEmpty(response.data.orderNumber)) {
            this.$store.commit("setOrderNumber", response.data.orderNumber);
            this.$router.push("/complete");
          } else {
            this.$router.push("/syserr");
          }
          //終了
          isInitialized = true;
        })
        .catch(error => {
          if(error.response.status == 400 && error.response.data){
            //バリデーションエラーあり（メッセージ設定表示）
            this.$refs.obs.setErrors(error.response.data);
            // バリデーション項目先頭へ自動スクロールさせる
            const elem = document.getElementById(Object.keys(error.response.data)[0]);
            elem.scrollIntoView(true);
            elem.focus();

          }else{
            this.$router.push("/syserr");
          }
          //システムエラー画面へ遷移
          isInitialized = false;
        }).finally(() => this.$store.commit("setIsInitialized", isInitialized))

    },

    onback: function() {
      this.$router.go(-1);
    },

    // ファイル送信処理
    onSubmit: function(fileType, fileImg) {
      //送信データはFormDataを使う
      let data = new FormData();
      //ファイル種別を追加
      data.append("fileType", fileType);
      data.append("multipartFile", fileImg);

      axios
        .post(
          this.$store.state.defaultParams.requestDomain + "/attachfile/upload",
          data
        )
        .then(response => {
          //storeへ保存する。
          this.$store.commit("set" + fileType + "Id", response.data);
        })
        .catch(error => { // eslint-disable-line no-unused-vars
          //システムエラー画面へ遷移
          this.$router.push("/syserr");
        });
    },

    // 画像バイナリデータ（健康保険証・表）
    async setInsuranceCardImageFront(e) {
      const {
        valid
      } = await this.$refs.insuranceCardImageFrontProvider.validate(e);
      if (valid) {
        const files = this.$refs.insuranceCardImageFront;
        const fileImg = files.files[0];
        //サーバーへファイル送信
        this.onSubmit("InsuranceCardImageFront", fileImg);
        if (fileImg.type.startsWith("image/")) {
          this.data.insuranceCardImageFrontImage = window.URL.createObjectURL(
            fileImg
          );
          this.data.insuranceCardImageFrontOnChanged = true;
          //状態保存
          this.$store.commit("setInsuranceCardImageFrontOnChanged", true);
          this.$store.commit(
            "setInsuranceCardImageFrontImage",
            this.data.insuranceCardImageFrontImage
          );
        }
      }
    },
    // 画像バイナリデータ（健康保険証・裏）
    async setInsuranceCardImageBack(e) {
      const {
        valid
      } = await this.$refs.insuranceCardImageBackProvider.validate(e);

      if (valid) {
        const files = this.$refs.insuranceCardImageBack;
        const fileImg = files.files[0];
        //サーバーへファイル送信
        this.onSubmit("InsuranceCardImageBack", fileImg);

        if (fileImg.type.startsWith("image/")) {
          this.data.insuranceCardImageBackImage = window.URL.createObjectURL(
            fileImg
          );
          this.data.insuranceCardImageBackOnChanged = true;
          //状態保存
          this.$store.commit("setInsuranceCardImageBackOnChanged", true);
          this.$store.commit(
            "setInsuranceCardImageBackImage",
            this.data.insuranceCardImageBackImage
          );
        }
      }
    },
    //画像バイナリデータ（介護保険証・表）
    async setCareInsuCardImageFront(e) {
      const {
        valid
      } = await this.$refs.careInsuCardImageFrontProvider.validate(e);

      if (valid) {
        const files = this.$refs.careInsuCardImageFront;
        const fileImg = files.files[0];
        //サーバーへファイル送信
        this.onSubmit("CareInsuCardImageFront", fileImg);
        if (fileImg.type.startsWith("image/")) {
          this.data.careInsuranceCardImageFrontImage = window.URL.createObjectURL(
            fileImg
          );
          this.data.careInsuranceCardImageFrontOnChanged = true;
          //状態保存
          this.$store.commit("setCareInsuranceCardImageFrontOnChanged", true);
          this.$store.commit(
            "setCareInsuranceCardImageFrontImage",
            this.data.careInsuranceCardImageFrontImage
          );
        }
      }
    },
    // 画像バイナリデータ（介護保険証・裏）
    async setCareInsuCardImageBack(e) {
      const { valid } = await this.$refs.careInsuCardImageBackProvider.validate(
        e
      );

      if (valid) {
        const files = this.$refs.careInsuCardImageBack;
        const fileImg = files.files[0];
        //サーバーへファイル送信
        this.onSubmit("CareInsuCardImageBack", fileImg);

        if (fileImg.type.startsWith("image/")) {
          this.data.careInsuranceCardImageBackImage = window.URL.createObjectURL(
            fileImg
          );
          this.data.careInsuranceCardImageBackOnChanged = true;
          //状態保存
          this.$store.commit("setCareInsuranceCardImageBackOnChanged", true);
          this.$store.commit(
            "setCareInsuranceCardImageBackImage",
            this.data.careInsuranceCardImageBackImage
          );
        }
      }
    }
  },

  computed: {

    requestDomain: {
      get() {
        return this.$store.state.defaultParams.requestDomain;
      },
      set(val) {
        this.$store.commit("setRequestDomain", val);
      }
    },

    inputFieldExplanation() {
      return this.$store.state.ehrSystem.inputFieldExplanation;
    },

    lastName: {
      get() {
        return this.$store.state.consentApplicant.lastName;
      },
      set(val) {
        this.$store.commit("setLastName", val);
      }
    },

    firstName: {
      get() {
        return this.$store.state.consentApplicant.firstName;
      },
      set(val) {
        this.$store.commit("setFirstName", val);
      }
    },
    maidenName: {
      get() {
        return this.$store.state.consentApplicant.maidenName;
      },
      set(val) {
        this.$store.commit("setMaidenName", val);
      }
    },
    lastNameKanaStr: {
      get() {
        return this.$store.state.consentApplicant.lastNameKanaStr;
      },
      set(val) {
        this.$store.commit("setLastNameKanaStr", val);
      }
    },
    firstNameKanaStr: {
      get() {
        return this.$store.state.consentApplicant.firstNameKanaStr;
      },
      set(val) {
        this.$store.commit("setFirstNameKanaStr", val);
      }
    },
    maidenNameKanaStr: {
      get() {
        return this.$store.state.consentApplicant.maidenNameKanaStr;
      },
      set(val) {
        this.$store.commit("setMaidenNameKanaStr", val);
      }
    },

    birthDateStr: {
      get() {
        return this.$store.state.consentApplicant.birthDateStr;
      },
      set(val) {
        this.$store.commit("setBirthDateStr", val);
      }
    },
    gender: {
      get() {
        return this.$store.state.consentApplicant.gender;
      },
      set(val) {
        this.$store.commit("setGender", val);
      }
    },
    postcodeNumStr: {
      get() {
        return this.$store.state.consentApplicant.postcodeNumStr;
      },
      set(val) {
        this.$store.commit("setPostcodeNumStr", val);
      }
    },
    prefectureStr: {
      get() {
        return this.$store.state.consentApplicant.prefectureStr;
      },
      set(val) {
        this.$store.commit("setPrefectureStr", val);
      }
    },
    city: {
      get() {
        return this.$store.state.consentApplicant.city;
      },
      set(val) {
        this.$store.commit("setCity", val);
      }
    },
    town: {
      get() {
        return this.$store.state.consentApplicant.town;
      },
      set(val) {
        this.$store.commit("setTown", val);
      }
    },
    lotNumber: {
      get() {
        return this.$store.state.consentApplicant.lotNumber;
      },
      set(val) {
        this.$store.commit("setLotNumber", val);
      }
    },
    detailAddress: {
      get() {
        return this.$store.state.consentApplicant.detailAddress;
      },
      set(val) {
        this.$store.commit("setDetailAddress", val);
      }
    },
    telNumber: {
      get() {
        return this.$store.state.consentApplicant.telNumber;
      },
      set(val) {
        this.$store.commit("setTelNumber", val);
      }
    },
    mobileNumber: {
      get() {
        return this.$store.state.consentApplicant.mobileNumber;
      },
      set(val) {
        this.$store.commit("setMobileNumber", val);
      }
    },
    emailAddress: {
      get() {
        return this.$store.state.consentApplicant.emailAddress;
      },
      set(val) {
        this.$store.commit("setEmailAddress", val);
      }
    },
    //保険証
    insuredCheck: {
      get() {
        return this.$store.state.consentApplicant.insuredCheck;
      },
      set(val) {
        this.$store.commit("setInsuredCheck", val);
      }
    },
    // 全角入力（被保険者記号）
    symbolToggle: {
      get() {
        return this.$store.state.symbolToggle;
      },
      set(val) {
        this.$store.commit("setSymbolToggle", val);
      }      
    },    
    insuredPersonSymbolStr: {
      get() {
        return this.$store.state.consentApplicant.insuredPersonSymbolStr;
      },
      set(val) {
        this.$store.commit("setInsuredPersonSymbolStr", val);
      }
    },
    // 全角入力（被保険者番号）
    numberToggle: {
      get() {
        return this.$store.state.numberToggle;
      },
      set(val) {
        this.$store.commit("setNumberToggle", val);
      }      
    },
    insuredPersonNumberStr: {
      get() {
        return this.$store.state.consentApplicant.insuredPersonNumberStr;
      },
      set(val) {
        this.$store.commit("setInsuredPersonNumberStr", val);
      }
    },
    insuredPersonBranchNumber: {
      get() {
        return this.$store.state.consentApplicant.insuredPersonBranchNumber;
      },
      set(val) {
        this.$store.commit("setInsuredPersonBranchNumber", val);
      }
    },
    insurerNumber: {
      get() {
        return this.$store.state.consentApplicant.insurerNumber;
      },
      set(val) {
        this.$store.commit("setInsurerNumber", val);
      }
    },
    //介護保険証
    careInsuredCheck: {
      get() {
        return this.$store.state.consentApplicant.careInsuredCheck;
      },
      set(val) {
        this.$store.commit("setCareInsuredCheck", val);
      }
    },
    careDescribedInsurerNumber: {
      get() {
        return this.$store.state.consentApplicant.careDescribedInsurerNumber;
      },
      set(val) {
        this.$store.commit("setCareDescribedInsurerNumber", val);
      }
    },
    careInsuredPersonNumber: {
      get() {
        return this.$store.state.consentApplicant.careInsuredPersonNumber;
      },
      set(val) {
        this.$store.commit("setCareInsuredPersonNumber", val);
      }
    },
    consentPath() {
      return this.$store.state.ehrSystem.rulePath;
    },
    ruleExplanation() {
      return this.$store.state.ehrSystem.ruleExplanation;
    },
    wdAraLnkConsentFlagBool: {
      get() {
        return this.$store.state.consentApplicant.wdAraLnkConsentFlagBool;
      },
      set(val) {
        this.$store.commit("setWdAraLnkConsentFlagBool", val);
      }
    },
    wdAraLnkDisplayName() {
      return this.$store.state.ehrSystem.wdAraLnkDisplayName;
    },
    wdAraLnkExplanation() {
      return this.$store.state.ehrSystem.wdAraLnkExplanation;
    },
    wdAraLnkRequiredFlag() {
      return this.$store.state.ehrSystem.wdAraLnkRequiredFlag === 1;
    },
    anonymizeFlagBool: {
      get() {
        return this.$store.state.consentApplicant.anonymizeFlagBool;
      },
      set(val) {
        this.$store.commit("setAnonymizeFlagBool", val);
      }
    },
    anonymizeDisplayName() {
      return this.$store.state.ehrSystem.anonymizeDisplayName;
    },
    anonymizeExplanation() {
      return this.$store.state.ehrSystem.anonymizeExplanation;
    },
    anonymizeRequiredFlag() {
      return this.$store.state.ehrSystem.anonymizeRequiredFlag === 1;
    },
    inclusiveConsFlagBool: {
      get() {
        return this.$store.state.consentApplicant.inclusiveConsFlagBool;
      },
      set(val) {
        this.$store.commit("setInclusiveConsFlagBool", val);
      }
    },
    inclusiveConsDisplayName() {
      return this.$store.state.ehrSystem.inclusiveConsDisplayName;
    },
    inclusiveConsExplanation() {
      return this.$store.state.ehrSystem.inclusiveConsExplanation;
    },
    inclusiveConsRequiredFlag() {
      return this.$store.state.ehrSystem.inclusiveConsRequiredFlag === 1;
    },

    applicantNotices: {
      get() {
        return this.$store.state.consentApplicant.applicantNotices;
      },
      set(val) {
        this.$store.commit("setApplicantNotices", val);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.imagePreview {
  width: 100%;
  height: 180px;
  background-position: center center;
  background-size: cover;
  display: inline-block;
}
input:placeholder-shown {
  border-color: #f33;
}
input:not(:placeholder-shown) {
  background-color: rgb(232, 240, 254) !important;
  border-color: green;
}
option:checked {
  background-color: rgb(232, 240, 254) !important;
}
.entered {
  background-color: rgb(232, 240, 254) !important;
}
input:valid {
  border: 1px solid #ced4da;
}
form:valid {
  border: 1px solid #ddffdd;
}
</style>
